import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { emailapi } from "../../Appjs/api.js";

export const emailApi = createApi({
  reducerPath: "emailApi",
  baseQuery: fetchBaseQuery({
    baseUrl: emailapi,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("accessToken");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["EmailTemplate"],
  endpoints: (builder) => ({
    PostEmailTemplate: builder.mutation({
      query: (data) => ({
        url: "/email/create-template",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["EmailTemplate"],
    }),
    getEmailTemplate: builder.query({
      query: () => "/email/get-templates",
      providesTags: ["EmailTemplate"],
    }),
    sendEmailCampaign: builder.mutation({
      query: (formData) => ({
        url: "/email/send-email",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["EmailTemplate"],
    }),
    getEmailCampaignReport: builder.query({
      query: ({ start_date, end_date }) =>
        `/email/get-logs?start_date=${start_date}&end_date=${end_date}`,
      providesTags: ["EmailTemplate"],
    }),
    getEmailLogs: builder.query({
      query: (id) => `/email/get-report/${id}`,
      providesTags: ["EmailTemplate"],
    }),
    editEmailTemplate: builder.mutation({
      query: ({ id, data }) => ({
        url: `/email/edit-template/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["EmailTemplate"],
    }),
  }),
});

export const {
  usePostEmailTemplateMutation,
  useGetEmailTemplateQuery,
  useSendEmailCampaignMutation,
  useGetEmailCampaignReportQuery,
  useLazyGetEmailCampaignReportQuery,
  useGetEmailLogsQuery,
  useEditEmailTemplateMutation,
} = emailApi;
